module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image5-f399ba0748d907451d36d02423993124.jpg";